import PropTypes from "prop-types";
import React, { useRef, useState, useEffect } from "react";
import PasswordInput from "components/inputs/PasswordInput";
import LockResetIcon from "@mui/icons-material/LockReset";
import {
  ChangePassword,
  getAllNotification,
  // AddAllFeedbacks,
} from "store/action/index";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  ButtonBase,
  CardContent,
  ClickAwayListener,
  Divider,
  Grid,
  Paper,
  Popper,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { dispatch } from "store/index";
import CircularProgress from "@mui/material/CircularProgress";
import { AES, enc } from "crypto-js";
import * as url from "../../../../../store/constant/Endpoints";
import { connect } from "react-redux";
import Avatar from "components/@extended/Avatar";
import MainCard from "components/MainCard";
import Transitions from "components/@extended/Transitions";
import { Button, Modal, Space, Input, Dropdown, Badge, Menu } from "antd";
import IconButton from "components/@extended/IconButton";
import avatar1 from "assets/images/users/avatar-6.png";
import { Logout } from "iconsax-react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import { color } from "../../../../../../node_modules/@mui/system/index";

// tab panel wrapper
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
      sx={{ p: 1 }}
    >
      {value === index && children}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number,
  index: PropTypes.number,
};

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

const ProfilePage = ({ notificationData }) => {
  const theme = useTheme();

  // let loginDetailsLocalStorage = localStorage.getItem("LoginData");
  // let loginDetails = JSON.parse(loginDetailsLocalStorage);
  const handleLogout = async () => {
    // Logout
    localStorage.clear();
    window.location.reload();
  };

  const [passwordVisible, setPasswordVisible] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [current_password, setcurrentPasssword] = useState("");
  const [password, setnewPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [feedback, setFeedback] = useState("");
  const [subject, setSubject] = useState("");

  const [validation, setValidation] = useState(false);
  // let userId = localStorage.getItem('Id');

  const [fieldErrors, setFieldErrors] = useState({
    current_password: "",
    password: "",
    confirmPassword: "",
    password: false,
    password_error_text: "",
    current_password_error_text: "",
    confirmPassword: false,
    c_password_error_text: "",
  });

  let permissionUser = localStorage.getItem("data");

  let decryptedData = null;
  if (permissionUser) {
    try {
      // Code that may throw an exception
      decryptedData = AES.decrypt(
        permissionUser,
        url.encryptionSecret,
      ).toString(enc.Utf8);
      // ...
    } catch (error) {
      console.log(error, "er");
    }
  }

  const loginDetails = JSON.parse(decryptedData);

  useEffect(() => {
    console.log("loginDetails", loginDetails);
  }, [loginDetails]);

  // console.log(loginDetails.image);
  const [userobj, setUserObj] = useState({
    current_password: "",
    password: "",
    confirmPassword: "",
  });

  const setPasswordValidation = (value, newPass, confirmNewPass) => {
    const newFieldErrors = { ...fieldErrors };

    if (value === "newPass") {
      if (newPass.length < 6) {
        newFieldErrors.password = true;
        newFieldErrors.password_error_text =
          "Password must be at least 6 characters";
      } else {
        newFieldErrors.password = false;
        newFieldErrors.password_error_text = "";
      }
    } else if (value === "confirmNewPass") {
      // Check password and confirm password match
      if (password !== confirmNewPass) {
        newFieldErrors.confirmPassword = true;
        newFieldErrors.c_password_error_text = "Password does not match";
      } else {
        newFieldErrors.confirmPassword = false;
        newFieldErrors.c_password_error_text = "";
      }
    } else {
      if (password.length < 6) {
        newFieldErrors.password = true;
        newFieldErrors.password_error_text =
          "Password must be at least 6 characters";
      } else {
        newFieldErrors.password = false;
        newFieldErrors.password_error_text = "";
      }

      // Check password and confirm password match
      if (password !== confirmPassword) {
        newFieldErrors.confirmPassword = true;
        newFieldErrors.c_password_error_text = "Password does not match";
      } else {
        newFieldErrors.confirmPassword = false;
        newFieldErrors.c_password_error_text = "";
      }
    }

    setFieldErrors(newFieldErrors);
  };

  const handleBlur = () => {
    setPasswordValidation();
  };

  const handleOk = () => {
    setLoading(true);
    setValidation(true);
    setPasswordValidation();
    const requiredFields = ["current_password", "password"];

    const newFieldErrors = { ...fieldErrors };

    // Check each required field
    requiredFields &&
      requiredFields.length !== 0 &&
      requiredFields.forEach((fieldName) => {
        if (!userobj[fieldName]) {
          newFieldErrors[fieldName] = `${fieldName} is required`;
        } else {
          newFieldErrors[fieldName] = "";
        }
      });

    setFieldErrors(newFieldErrors);

    if (password.length >= 6 && password != confirmPassword) {
      setModalOpen(false);
    }

    const hasErrors = Object.values(newFieldErrors).some(
      (error) => error !== "",
    );

    if (!newFieldErrors?.confirmPassword) {
      dispatch(
        ChangePassword({
          current_password: current_password,
          password: password,
          setModalOpen: setModalOpen,
          setLoading: setLoading,
        }),
      );
      //   setModalOpen(false);
    }
  };
  const handleCancel = () => {
    setModalOpen(false);
  };
  // useEffect(() => {
  //   dispatch(getAllNotification());
  // }, []);

  useEffect(() => {
    // console.log("nenenenen", notificationData?.notificationData?.data?.count);
  }, [notificationData]);

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [userAgainData, setUserAgain] = useState();
  const [notificationModalView, setNotiModalView] = useState(false);

  const handleChange = () => {
    setModalOpen(true);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const items = [
    {
      key: "1",
      label: "First",
    },
    {
      key: "2",
      label: "Second",
    },
    {
      key: "3",
      label: "Third",
    },
  ];

  const handleItemClick = (itemName) => {
    setUserAgain(itemName.data);
    setNotiModalView(true);
  };

  const handleCancelNoti = () => {
    setNotiModalView(false);
  };

  if (permissionUser) {
    try {
      // Code that may throw an exception
      decryptedData = AES.decrypt(
        permissionUser,
        url.encryptionSecret,
      ).toString(enc.Utf8);
      // ...
    } catch (error) {
      localStorage.clear();
      window.location.reload();
    }
  }

  const permissionsAssrray =
    decryptedData && JSON.parse(decryptedData)?.user_type;

  const handleClickk = () => {
    const payload = {
      email: email,
      subject: subject,
      feedback: feedback,
    };
    // dispatch(AddAllFeedbacks({ payload, setLoading }));
  };

  const handleClick = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };
  const { TextArea } = Input;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        flexShrink: 0,
        ml: 0.75,
      }}
    >
      <IconButton
        size="small"
        sx={{
          p: "7px",
          borderRadius: "8px",
          color: "grey.700",
          "&:hover": { bgcolor: "rgba(0,0,0,0.06)" },
          transition: "background 0.2s",
        }}
      >
        <SearchOutlinedIcon sx={{ fontSize: 17 }} />
      </IconButton>

      {/* Notifications */}
      <IconButton
        size="small"
        sx={{
          p: "7px",
          borderRadius: "8px",
          color: "grey.700",
          position: "relative",
          "&:hover": { bgcolor: "rgba(0,0,0,0.06)" },
          transition: "background 0.2s",
        }}
      >
        <NotificationsOutlinedIcon sx={{ fontSize: 17 }} />
        {/* Red dot */}
        <Box
          sx={{
            position: "absolute",
            top: 6,
            right: 6,
            width: 7,
            height: 7,
            borderRadius: "50%",
            bgcolor: "#ef4444",
          }}
        />
      </IconButton>

      {/* Mail */}
      <IconButton
        size="small"
        sx={{
          p: "7px",
          borderRadius: "8px",
          color: "grey.700",
          "&:hover": { bgcolor: "rgba(0,0,0,0.06)" },
          transition: "background 0.2s",
        }}
      >
        <MailOutlinedIcon sx={{ fontSize: 17 }} />
      </IconButton>

      {/* Vertical Divider */}
      <Divider
        orientation="vertical"
        flexItem
        sx={{
          mx: 0.5,
          borderColor: "divider",
          opacity: 0.9,
        }}
      />

      {/* Profile Button */}
      <ButtonBase
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.75,
          px: 1,
          py: 0.5,
          borderRadius: 2,
          "&:hover": { bgcolor: "rgba(0,0,0,0.04)" },
        }}
        aria-label="open profile"
        ref={anchorRef}
        aria-controls={open ? "profile-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        {/* Avatar */}
        <Avatar
          sx={{
            width: 32,
            height: 32,
            background:
              "#02462E",
            fontSize: 13,
            fontWeight: 700,
            color: "#fff",
          }}
          alt="profile user"
          src={
            loginDetails?.image !== null && loginDetails?.image !== ""
              ? loginDetails?.image
              : avatar1
          }
        />

        {/* Welcome + Name */}
        <Box sx={{ textAlign: "left" }}>
          <Typography
            sx={{
              fontSize: 10,
              color: "grey.500",
              lineHeight: 1.3,
              fontWeight: 400,
            }}
          >
            Welcome
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.3 }}>
            <Typography
              sx={{
                fontSize: 12,
                fontFamily: "icertxBold, Poppins, sans-serif",
                fontWeight: 900,
                color: "#262626",
                lineHeight: 1.3,
              }}
            >
              {loginDetails?.name ?? "User"}
            </Typography>
            <svg
              width="11"
              height="11"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ marginTop: 1, color: "#666" }}
            >
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </Box>
        </Box>
      </ButtonBase>

      {/* Dropdown Popper */}
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [{ name: "offset", options: { offset: [0, 9] } }],
        }}
      >
        {({ TransitionProps }) => (
          <Transitions
            type="grow"
            position="top-right"
            in={open}
            {...TransitionProps}
          >
            <Paper
              sx={{
                boxShadow: theme.customShadows.z1,
                width: 270,
                minWidth: 220,
                maxWidth: 270,
                [theme.breakpoints.down("md")]: { maxWidth: 240 },
                borderRadius: 1.5,
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard sx={{ border: "none" }} content={false}>
                  <CardContent sx={{ px: 2, py: 2 }}>
                    {/* Profile Info */}
                    <Stack
                      direction="row"
                      spacing={1.25}
                      alignItems="center"
                      mb={1.5}
                      width="100%"
                    >
                      <Avatar
                        sx={{
                          width: 36,
                          height: 36,
                          background:
                            "#02462E",
                          color: "#fff",
                          fontSize: 14,
                          fontWeight: 700,
                          flexShrink: 0,
                        }}
                        alt="profile user"
                        src={
                          loginDetails?.image !== null &&
                          loginDetails?.image !== ""
                            ? loginDetails?.image
                            : avatar1
                        }
                      />
                      <Stack sx={{ minWidth: 0 }}>
                        <Typography variant="subtitle2" fontWeight={600} noWrap>
                          {loginDetails?.name || "No Name"}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{ color: "#555", fontSize: 11 }}
                          noWrap
                        >
                          {loginDetails?.user_detail?.email || "No Email"}
                        </Typography>
                      </Stack>
                    </Stack>

                    {/* Divider */}
                    <Box
                      sx={{
                        borderTop: "1px solid",
                        borderColor: "divider",
                        mb: 1,
                      }}
                    />

                    {/* Actions Row */}
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#777",
                          textTransform: "capitalize",
                          fontSize: 11,
                        }}
                      >
                        {loginDetails?.role_name || ""}
                      </Typography>
                      <Stack direction="row" spacing={0.5}>
                        <Tooltip title="Change Password">
                          <IconButton
                            size="small"
                            onClick={handleChange}
                            sx={{
                              color: "#f59e0b",
                              bgcolor: "rgba(245,158,11,0.08)",
                              "&:hover": { bgcolor: "rgba(245,158,11,0.18)" },
                              borderRadius: "8px",
                              width: 32,
                              height: 32,
                            }}
                          >
                            <LockResetIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Logout">
                          <IconButton
                            size="small"
                            onClick={handleLogout}
                            sx={{
                              color: "#ef4444",
                              bgcolor: "rgba(239,68,68,0.08)",
                              "&:hover": { bgcolor: "rgba(239,68,68,0.18)" },
                              borderRadius: "8px",
                              width: 32,
                              height: 32,
                            }}
                          >
                            <Logout variant="Bulk" />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </Stack>
                  </CardContent>

                  {/* Change Password Modal */}
                  <Modal
                    open={isModalOpen}
                    title="Change Password"
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[
                      <Button key="back" onClick={handleCancel}>
                        Cancel
                      </Button>,
                      <Button
                        key="submit"
                        style={{ backgroundColor: "#1677ff" }}
                        type="primary"
                        onClick={handleOk}
                      >
                        {loading ? (
                          <CircularProgress size={14} color="inherit" />
                        ) : (
                          "Change Password"
                        )}
                      </Button>,
                    ]}
                  >
                    <br />
                    <div className="my-2">
                      <PasswordInput
                        value={current_password}
                        onBlur={handleBlur}
                        onChange={(e) => setcurrentPasssword(e.target.value)}
                        type="password"
                        name="Current Password*"
                        placeholder="Current Password*"
                        error={fieldErrors.current_password}
                        errorText={fieldErrors.current_password_error_text}
                      />
                    </div>
                    <div className="my-2">
                      <PasswordInput
                        value={password}
                        onBlur={handleBlur}
                        onChange={(e) => {
                          setnewPassword(e.target.value);
                          setPasswordValidation("newPass", e.target.value, "");
                        }}
                        type="password"
                        name="Password*"
                        placeholder="Password*"
                        error={fieldErrors.password}
                        errorText={fieldErrors.password_error_text}
                      />
                    </div>
                    <div className="my-2">
                      <PasswordInput
                        value={confirmPassword}
                        onBlur={handleBlur}
                        name="Confirm Password*"
                        placeholder="Confirm Password"
                        onChange={(e) => {
                          setconfirmPassword(e.target.value);
                          setPasswordValidation(
                            "confirmNewPass",
                            "",
                            e.target.value,
                          );
                        }}
                        error={fieldErrors.confirmPassword}
                        errorText={fieldErrors.c_password_error_text}
                      />
                    </div>
                  </Modal>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    notificationData: state?.Notificationgetall,
  };
};

export default connect(mapStateToProps)(ProfilePage);
